<template>
  <router-view />
</template>

<script setup>
// 根组件：只负责路由渲染，所有页面布局在各自视图里自己渲染
</script>
